export default __webpack_public_path__ + "static/media/github-api.3a5ccf39.svg";